export const MODE_MULTIPLE = 'multiple';
export const MODE_SINGLE = 'single';
